/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EvmWallet,
    EvmWalletFromJSON,
    EvmWalletFromJSONTyped,
    EvmWalletToJSON,
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetGameDataResponse
 */
export interface GetGameDataResponse {
    /**
     * 
     * @type {User}
     * @memberof GetGameDataResponse
     */
    user?: User;
    /**
     * 
     * @type {Array<EvmWallet>}
     * @memberof GetGameDataResponse
     */
    wallets?: Array<EvmWallet>;
}

export function GetGameDataResponseFromJSON(json: any): GetGameDataResponse {
    return GetGameDataResponseFromJSONTyped(json, false);
}

export function GetGameDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGameDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'wallets': !exists(json, 'wallets') ? undefined : ((json['wallets'] as Array<any>).map(EvmWalletFromJSON)),
    };
}

export function GetGameDataResponseToJSON(value?: GetGameDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': UserToJSON(value.user),
        'wallets': value.wallets === undefined ? undefined : ((value.wallets as Array<any>).map(EvmWalletToJSON)),
    };
}


